import { useCallback, useEffect, useRef, useState } from 'react'
import { Icone } from './Icone'

/** Le bandeau de confirmation (équivalent de `toast()`), avec un minuteur propre au composant. */
export function useNotification() {
  const [message, setMessage] = useState<string | null>(null)
  const minuteur = useRef<ReturnType<typeof setTimeout> | null>(null)

  const notifier = useCallback((m: string) => {
    setMessage(m)
    if (minuteur.current) clearTimeout(minuteur.current)
    minuteur.current = setTimeout(() => setMessage(null), 3200)
  }, [])

  useEffect(() => () => {
    if (minuteur.current) clearTimeout(minuteur.current)
  }, [])

  const bandeau = (
    <div className={`toast${message ? ' on' : ''}`} role="status" aria-live="polite">
      {message && (
        <>
          <Icone nom="check" taille={16} />
          <span>{message}</span>
        </>
      )}
    </div>
  )
  return { notifier, bandeau }
}
